import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { kycApprovalBusinessService } from 'services';

const slice = createSlice({
  name: 'kycApprovalBusiness',
  // initialState: booksAdapter.getInitialState(),
  initialState: { ids: [], entities: {}, dirty: true, busy: false, currentRequestId: null },
  reducers: {
    setBusy(state, action) {
      state.busy = action.payload;
    },
    setCurrentRequestId(state, action) {
      state.currentRequestId = action.payload;
    },
    add(state, action) {
      const { resData } = action.payload;

      //TODO : review - temp assuming flush true
      // const flush = action.payload.flush || true;
      const flush = true;

      let existingData = state.entities || {};
      let existingIds = state.ids || [];

      let entities = {
        ...existingData,
      };

      let ids = existingIds.concat([]);

      if (flush) {
        entities = {};
        ids = [];
      }

      // debugger;

      _.each(resData, (item, id) => {
        if (parseInt(id)) {
          entities[id] = {
            // isListLoaded: true,
            ...(entities[id] || {}),
            ...item,
          };
          if (!ids.includes(id)) {
            ids.push(id);
          }
        }
      });

      state['entities'] = entities;
      state['ids'] = ids;
      state['dirty'] = false;
      state['updatedAt'] = Date.now();

      // state.fetching = false;
    },

    update(state, action) {
      if (action.payload.flush === true) {
        state = action.payload;
        return state;
      }

      state = {
        ...state,
        ...action.payload,
        updatedAt: Date.now(),
      };
      // state['updatedAt'] = utils.uid();
    },
    create(state, action) {
      // @TODO: pass person_id filed value to post & handle response
      api.createSocialPost(action.payload);
    },
    delete(state, action) {
      // debugger;
      const post_id = action.payload;
      let order = _.get(state, 'order', []) || [];
      // const posts = state.data.filter(p => p.post_id !== post_id)
      delete state['data'][post_id];
      let filteredOrder = order.filter((id) => id !== post_id);
      state['order'] = filteredOrder;
    },
    setDirty(state, action) {
      state = { ids: [], entities: {}, dirty: true };
      return state;
    },
  },
});

const fetchList = (params) => async (dispatch, getState) => {
  const requestId = Date.now();
  dispatch(slice.actions.setCurrentRequestId(requestId));
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await kycApprovalBusinessService.fetchList(params);
    if (getState().kycApprovalBusiness.currentRequestId !== requestId) return;
    dispatch(slice.actions.add({ resData }));
  } catch (err) {
    if (getState().kycApprovalBusiness.currentRequestId === requestId) {
      dispatch(slice.actions.add({ resData: {} }));
      utils.displayErrors(err);
    }
  }
  if (getState().kycApprovalBusiness.currentRequestId === requestId) {
    dispatch(slice.actions.update({}));
    dispatch(slice.actions.setBusy(false));
  }
};

const actions = {
  ...slice.actions,
  fetchList,
};

const selectors = {
  // selectLoader,
};

export { actions, selectors };

export default slice.reducer;
